import { createGlobalState } from "@vueuse/core";
import { computed } from "vue";
import { useLocationStore } from "../LocationStore/useLocationStore";
import { useSystemStore } from "../SystemStore/useSystemStore";
import { useSharedStoreUserGroups } from "./useSharedStoreUserGroups";
import { useSharedStoreUsers } from "./useSharedStoreUsers";

export const useSharedStore = createGlobalState(
  () => {
    const usersStore = useSharedStoreUsers();
    const userGroupsStore = useSharedStoreUserGroups();
    const { locations } = useLocationStore();
    const systemStore = useSystemStore();
    const properties = computed(() => {
      const arr = systemStore.properties.value;
      return arr.reduce((acc, p) => {
        acc[p["@id"]] = p;
        return acc;
      }, {} as Record<string, typeof arr[0]>);
    });

    function reset() {
      usersStore._reset();
      userGroupsStore._reset();
    }

    return {
      ...usersStore,
      ...userGroupsStore,
      locations,
      properties,
      reset,
    };
  },
);
